import { render, staticRenderFns } from "./down.vue?vue&type=template&id=a5eb2214&scoped=true"
import script from "./down.vue?vue&type=script&lang=js"
export * from "./down.vue?vue&type=script&lang=js"
import style0 from "./down.vue?vue&type=style&index=0&id=a5eb2214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5eb2214",
  null
  
)

export default component.exports